<template>
  <v-dialog
    scrollable
    v-model="baseDialog"
    persistent
    :width="width"
    :eager="eager"
    v-bind="$attrs"
  >
    <v-card>
      <v-card-title class="heading lighten-3">
        <h5
          class="text_color--text text-uppercase font-weight-bold"
          v-if="title"
        >
          {{ title }}
        </h5>
        <v-spacer></v-spacer>
        <span>
          <v-icon class="text_color--text" @click.stop="closeDialog"
            >mdi-close</v-icon
          >
        </span>
      </v-card-title>

      <v-card-text
        :class="cardTextClass"
        :style="{
          maxHeight: height,
        }"
      >
        <slot name="information"></slot>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions v-if="btnEnable" class="d-flex justify-end">
        <slot name="action"> </slot>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  components: {},
  props: {
    height: {
      type: String,
      default: "80vh",
    },
    width: {
      type: String,
      default: "800",
    },
    title: {
      type: String,
      required: true,
    },
    actionAllow: {
      type: Boolean,
      default: false,
    },
    btnEnable: {
      type: Boolean,
      default: false,
    },
    cardTextClass: {
      type: String,
    },
    value: Boolean,
    eager: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    baseDialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    closeDialog() {
      this.baseDialog = false;
      this.$emit("reset");
    },
  },
};
</script>
